// import qs from "qs";

import { Api } from "./api/Api";

const API = new Api({
  securityWorker: async () => {
    const headers: Record<string, string> = {
      // Authorization: `Bearer...`
      "Access-Control-Allow-Origin": "*",
    };

    return { headers };
  },
  baseApiParams: {
    secure: true,
    format: "json",
  },
  baseUrl: (process.env.REACT_APP_API_URL || "http://localhost:4000").trim(),
});

export default API;
